import React, { useState, useEffect } from "react";
import { api } from '../../utils/apiClient';
import { Button } from 'antd';
import { useNavigate } from "react-router-dom";
import { TGDataTable } from '../common';

const Roles = () => {
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    // Column definitions for TGDataTable
    const columns = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 100,
            fixed: 'left',
            render: (text) => <span style={{ fontFamily: 'Monaco, monospace', fontSize: 11 }}>{text}</span>,
            sortable: true,
            filterable: true,
            filterType: 'number',
        },
        {
            key: 'name',
            title: 'Name',
            dataIndex: 'name',
            width: 200,
            sortable: true,
            filterable: true,
            filterType: 'text',
            ellipsis: true,
        },
        {
            key: 'description',
            title: 'Description',
            dataIndex: 'description',
            width: 400,
            sortable: true,
            filterable: true,
            filterType: 'text',
            ellipsis: true,
        }
    ];

    useEffect(() => {
        const fetchRoles = async() => {
            try {
                const response = await api.get('/roles');
                console.log('Fetched roles', response.data);
                setRoles(response.data);
                setLoading(false);
            } catch (error) {
                console.log('Error fetching roles', error);
                setLoading(false);
            }
        };
        fetchRoles();
    }, []);

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '16px' }}>
                <Button
                    type="primary"
                    onClick={() => navigate('/api/create-role')}
                    size="large"
                >
                    Create New Role
                </Button>
            </div>

            <TGDataTable
                data={roles}
                columns={columns}
                loading={loading}
                rowKey="id"
                pagination="client"
                pageSize={10}
                showExport
                showColumnConfig
                exportFilename="roles"
                presetKey="admin.roles"
            />
        </div>
    );
}

export default Roles;